<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const PromotionsIcon = getIcon("PromotionsIcon");
export let className = "";
</script>

{#if typeof PromotionsIcon === 'string'}
	<img src={PromotionsIcon} alt={$t(Verbiage.icon_alt, 'alts')} class={className} />
{:else if typeof PromotionsIcon === 'function'}
	<svelte:component this={PromotionsIcon} {className} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
